export default {
  newWindow: 'Wird in einem neuen Fenster geöffnet',
}
